module.exports = __webpack_public_path__ + "img/pen-active.c79bab9f.svg";